import React from "react";
import Heading from "../components/heading";
import Layout from "../components/layout";
import Text from "../components/text";
import { ExternalLink } from "../components/link";
import FeatureBox from "../components/feature-box";
import AboutImg from '../images/mobileapps.jpg'

function SubmitArtPage() {
    return (
        <Layout title="Submit art">
            <FeatureBox><img style={{maxWidth: '100%', border: 'none'}} src={AboutImg} /></FeatureBox>
            
            <div style={{maxWidth: '900px', margin: '40px auto 24px'}}>
                
                <Heading mbLarge>Submit Art</Heading>
                <Text marginBelow>Found or made some public art you want to share?</Text>
                <ExternalLink href="https://businessandartsnl.com/explore-art-nl-2/explore-art-nl/include-this/">
                    Submit public art here
                </ExternalLink>
            </div>
        </Layout>
    )
}

export default SubmitArtPage